import React, { useEffect, useRef, useState  } from 'react';
import { Container, Row, Col, Form } from "react-bootstrap";
import { Link,useNavigate } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';
import { useSearchParams } from "react-router-dom";
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import Loader from '../Common/loader';

const DeliveryDetails = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [cartDetails, setCartDetails] = useState(false);
    const selectedFileDetails = useRef(false);

    const getInitiator =async ()=>{
        // Get Delivery Order Details
        // api/account/deliveryorder/:donum
        var url=`account/deliveryorder/DO22`;
        await Axios.get(url)
        .then(function (response) {
            if (response && response.data?.data) {
                setCartDetails(response.data?.data);
            }
            else {
            toast.error(response.statusText ?? "Data fetching failed !", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
            }
        })
        .catch(function (error) {
            // navigate('/');
        });
    }

    useEffect(() => {
        if(searchParams.get("donum"))
            getInitiator();
    }, [searchParams.get("donum")]);

    const handleFileChange =async (e)=>{
        selectedFileDetails.current = e.target.files[0];
        // Upload file to Delivery Order
        // api/account/fileupload
        var formData = new FormData();
        formData.append('file', e.target.files[0])
        formData.append('module', "DO")
        formData.append('refnum', searchParams.get("donum"))
        var url=`account/fileupload`;
        await Axios.post(url,formData)
        .then(function (response) {
            if (response && response.data?.success) {
                setCartDetails(response.data?.data);
            }
            else {
            toast.error("Document Upload Failed !", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
            }
        })
        .catch(function (error) {
            // navigate('/');
        });
    }

    async function updateCartItems(e, itemDetails, qty, direct = false) {
        e.preventDefault();
        itemDetails.receivedqty=parseInt(itemDetails.receivedqty);
        if (direct) {
            itemDetails.receivedqty = parseInt(qty);
        } else {
            itemDetails.receivedqty += qty;
        }
        // Update Delivery Order
        // api/account/deliveryorder
        await Axios.post(`/account/deliveryorder`,
        {
            "items": [
                {
                    "donum": searchParams.get("donum"),
                    "matnum": itemDetails.matnum,
                    "receivedqty": itemDetails.receivedqty
                }
            ]
    
        })
        .then(async (data) => {
            if(data?.data?.success && data?.data?.data?.items){
                toast.success('Qty updated successfully !', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }
            else{
                toast.error(data.statusText, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }
        });

        setCartDetails(false)
        getInitiator();
    }

    return (
        <section className="main-container col1-layout">
            <Container className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                <div className="box-border">
                                    <h2>Delivery Order Details</h2>
                                    <h3 className="checkout-sep" style={{ paddingBottom: "10px" }}>Order No : {cartDetails?.deliveryorders?.ordernum}</h3>
                                    <h5><strong>Order Date:</strong> {cartDetails?.deliveryorders?.deldate}</h5>
                                    <h5><strong>Status:</strong> {cartDetails?.deliveryorders?.status}</h5>
                                    <br />
                                    <div className="order-detail-content table-responsive">
                                        <table className="table table-bordered jtv-cart-summary">
                                            <thead>
                                                <tr>
                                                    <th className="cart_product">Product</th>
                                                    <th>Description</th>
                                                    <th>Qty</th>
                                                    <th>RQty</th>
                                                </tr>
                                            </thead>
                                            {cartDetails &&  cartDetails.items ?
                                            <>
                                            <tbody>
                                            
                                            {cartDetails.items.map((item,i)=>{
                                                return (
                                                <tr key={i}>
                                                    <td className="cart_product"><Link to="/order-details">
                                                        <img src={AuthVerify.getImageLink(item?.imageurl)} alt="Product" /></Link></td>
                                                    <td colSpan="1" className="cart_description"><p className="product-name"><Link to={"/product-detail?matnum="+item?.matnum}> {item?.matname}</Link></p>
                                                        <small className="cart_ref">Matnum : {item.matnum}</small><br />
                                                        <small><Link to={AuthVerify.getImageLink(item.imageurl)}>Color : White</Link></small><br /></td>
                                                    <td>
                                                        {item.qty }
                                                    </td>
                                                    <td className="qty">
                                                        <input className="form-control input-sm" type="number" defaultValue={item.receivedqty} onChange={(event)=>{event.target.value=Math.max(0, Math.min(item.receivedqty, Number(event.target.value)))}} onBlur={(e) => updateCartItems(e, item, e.target.value, true)} />
                                                        {item.receivedqty > 1 && <Link to="/" onClick={(e) => updateCartItems(e, item, -1)}><i className="fa fa-minus"></i></Link>}
                                                        <Link to="/" onClick={(e) => updateCartItems(e, item, 1)}><i className="fa fa-plus"></i></Link>
                                                    </td>
                                                </tr>)
                                            })}
                                            </tbody>
                                            
                                            {/* <tfoot>
                                                <tr>
                                                <td colSpan="2" rowSpan="5">
                                                    <div className="input-group mb-3" style={{
                                                        display: "flex", width: "80%"
                                                    }}>
                                                        <input type="text" id="coupon" name="coupon" title="coupon" className="input form-control"
                                                            placeholder="No Promo Code Applied"
                                                            value={cartDetails?.carth?.promocode}
                                                            readOnly={true}
                                                            style={{
                                                                marginTop: "0px",
                                                                marginRight: "0px",
                                                                padding: "0px"
                                                            }} />
                                                    </div>
                                                </td>
                                                    <td colSpan="1">Subtotal</td>
                                                    <td colSpan="1">S${(cartDetails?.deliveryorders?.grossamt??0).toFixed(3)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1"><strong>Discount</strong></td>
                                                    <td colSpan="1"><strong>S${(cartDetails?.deliveryorders?.discamt??0).toFixed(3)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1"><strong>Shipping Amount</strong></td>
                                                    <td colSpan="1"><strong>S${(cartDetails?.deliveryorders?.shippingamt??0).toFixed(3)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1"><strong>GST</strong></td>
                                                    <td colSpan="1"><strong>S${(cartDetails?.deliveryorders?.gstamt??0).toFixed(3)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="1"><strong>Grand Total</strong></td>
                                                    <td colSpan="1"><strong>S${(cartDetails?.deliveryorders?.totalamt??0).toFixed(3)}</strong></td>
                                                </tr>
                                            </tfoot> */}
                                            </>:
                                            <tr>
                                                {cartDetails.items!=null ? <td colSpan="6"><Loader/></td>:<td colSpan="6" style={{textAlign:'center'}}>No products found !</td>}
                                            </tr>
                                            }
                                        </table>
                                    </div>
                                </div>
                                
                                <div className="box-border">
                                    <div className="box-account">
                                        <div className="page-title">
                                            <h2>Shipping Information</h2>
                                        </div>
                                        <div className="col2-set">
                                            <div className="col-1">
                                                <p><strong>Requestor Name:</strong> {cartDetails?.deliveryorders?.shipptc }<br /></p>
                                            </div>
                                        </div>
                                        <div className="col2-set">
                                            <div className="col-2">
                                                <h5>Shipping Address</h5>
                                                <address>
                                                    {cartDetails?.deliveryorders?.shipaddr1 }<br />
                                                    {cartDetails?.deliveryorders?.shippostcode } <br />
                                                </address>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="page-title">
                                            <h2>Delivery Date</h2>
                                        </div>
                                        <div className="col2-set">
                                            <div className="col-1">
                                                <p><strong>Selected Date:</strong> {cartDetails.deliveryorders?.deldate?cartDetails.deliveryorders?.deldate.split('T')[0]:''}<br /></p>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="page-title">
                                            <h2>Upload file</h2>
                                        </div>
                                        <div className="col2-set">
                                            <div className="col-1">
                                                <input type="file" onChange={handleFileChange}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="cart_navigation" style={{ marginBottom: '10px' }}>
                                <button className="button btn-proceed-checkout" title="Reorder" type="button" onClick={() => navigate('/my-account?activeKey=DeliveryOrder')}><span>Return to Delivery Order Listing</span></button>
                                    {/* <button onClick={()=>{setSaveAsTemplateModal(true)}} className="button btn-proceed-checkout" title="Save As Template" type="button">
                                        <span>Save As Template</span>
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container >
        </section >
    )
}
export default DeliveryDetails;

